interface Props {
  customCss?: string;
}

export default function CustomCssInjector({ customCss }: Props) {
  if (!customCss) return null;
  return <style>{customCss}</style>;
}
